import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HistoryIcon from '@mui/icons-material/History';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { blurredActionSx } from './blurStyles';
import { BUILD_INTRO_TEXT, UPDATE_INTRO_TEXT } from './constants';
import { formatProfileUpdatedAt } from './utils';
import HowThisWorksModal from './HowThisWorksModal';
import ResetCompanyProfileModal from './ResetCompanyProfileModal';

const CompanyProfileHeader = ({ mode, updatedAt, onReset, isResetting = false, showReset = false }) => {
  const isUpdate = mode === 'update' || mode === 'built';
  const canReset = showReset || isUpdate;
  const [howItWorksOpen, setHowItWorksOpen] = useState(false);
  const [resetOpen, setResetOpen] = useState(false);

  const handleConfirmReset = async () => {
    await onReset?.();
    setResetOpen(false);
  };

  return (
    <Box mb={3}>
      <Box display='flex' alignItems='flex-start' justifyContent='space-between' gap={2} mb={1}>
        <Typography variant='h4' fontWeight={700}>
          Company Profile
        </Typography>
        <Box display='flex' gap={1} flexWrap='wrap' justifyContent='flex-end'>
          <Button
            variant='outlined'
            size='small'
            startIcon={<InfoOutlinedIcon />}
            onClick={() => setHowItWorksOpen(true)}
            sx={{ textTransform: 'none' }}
          >
            How this works
          </Button>
          {canReset && (
            <Button
              variant='outlined'
              size='small'
              startIcon={<RestartAltIcon />}
              onClick={() => setResetOpen(true)}
              disabled={isResetting}
              sx={{ textTransform: 'none' }}
            >
              Reset
            </Button>
          )}
        </Box>
      </Box>

      <Typography variant='body1' color='text.secondary' sx={{ maxWidth: 860, lineHeight: 1.6, mb: 2 }}>
        {isUpdate ? UPDATE_INTRO_TEXT : BUILD_INTRO_TEXT}
      </Typography>

      {isUpdate && (
        <Box display='flex' alignItems='center' gap={1.5} flexWrap='wrap'>
          <Typography variant='body2' color='text.secondary'>
            Profile last updated: {formatProfileUpdatedAt(updatedAt)}
          </Typography>
          <Button
            size='small'
            disabled
            startIcon={<HistoryIcon />}
            sx={{ textTransform: 'none', ...blurredActionSx }}
          >
            View update history
          </Button>
        </Box>
      )}

      <HowThisWorksModal open={howItWorksOpen} onClose={() => setHowItWorksOpen(false)} />
      <ResetCompanyProfileModal
        open={resetOpen}
        onClose={() => setResetOpen(false)}
        onConfirm={handleConfirmReset}
        isLoading={isResetting}
      />
    </Box>
  );
};

export default CompanyProfileHeader;
